import { format } from "date-fns/format";
import { PeriodDate, TimePeriod } from "../../types/Artist";

export const getDateString = (timePeriod: TimePeriod): string => {
    const origin = getPeriodString(timePeriod.origin);
    const end = getPeriodString(timePeriod.end);
    return origin + ' - ' + end;
}

export const getPeriodString = (period: PeriodDate | undefined): string => {
    let dateString = '';
    if (period !== undefined && period.year !== undefined && period.year > 0) {
        dateString += period.year;
    }
    
    if (period !== undefined && period.month !== undefined && period.month > 0) {    
        const month = format(new Date(`${period.month}-01-1970`), 'MMMM');
        if (period !== undefined && period.date !== undefined && period.date > 0) {
            dateString = month + ' ' + period.date +  ', ' +dateString;
        } else {
            dateString = month + ' ' + dateString;
        }
    }

    return dateString;
}